import KeyValueResponsive from './KeyValueResponsive';

export default KeyValueResponsive;
export { KeyValueResponsive };
